import { Component } from "react";
import TableNew, { CELL_TYPES } from "../../../../shared/Table";
import Button from "@material-ui/core/Button";
import { DatePicker } from "@material-ui/pickers/DatePicker";

import JSONTree from "react-json-tree";

import moment from "moment";

class EventTableDetails extends Component {
  render() {
    return (
      <div className="row">
        <div className="col-md-12">
          <h4> Additional info </h4>
          <JSONTree hideRoot={true} data={this.props.item["Item2"]} />
        </div>
      </div>
    );
  }
}

class EventTableComponent extends Component {
  constructor(props) {
    super(props);

    let columns = [
      { key: "Id", label: "Stream key", visible: true, type: CELL_TYPES.text },
      {
        key: "SequenceNumber",
        label: "Sequence number",
        visible: true,
        type: CELL_TYPES.text,
      },
      {
        key: "Item1",
        label: "Event name",
        visible: true,
        type: CELL_TYPES.text,
      },
      {
        key: "TimeStamp",
        label: "Time stamp",
        visible: true,
        type: CELL_TYPES.date,
      },
    ];

    var today = new Date();
    var yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    this.state = { columns, from: yesterday, to: today };
  }

  filterClick = () => {
    this.props.getEvents(
      moment(this.state.from).format("YYYY-MM-DD"),
      moment(this.state.to).format("YYYY-MM-DD"),
    );
    this.props.changeEventListPage(1);
  };

  setFromDate = (value) => {
    this.setState({
      ...this.state,
      from: value,
    });
  };

  setToDate = (value) => {
    this.setState({
      ...this.state,
      to: value,
    });
  };

  render() {
    return (
      <div className="applications-layout body-height content-padding">
        <h3>Event list table:</h3>
        <div className="row">
          <div className="col-md-6">
            From date
            <br />
            <DatePicker
              inputVariant="outlined"
              className="small-datepicker"
              value={this.state.from}
              onChange={this.setFromDate}
              helperText="From date"
            />
          </div>
          <div className="col-md-6">
            To date
            <br />
            <DatePicker
              inputVariant="outlined"
              className="small-datepicker"
              value={this.state.to}
              onChange={this.setToDate}
              helperText="To date"
            />
          </div>
          <div className="col-md-12">
            <Button
              variant="outlined"
              color="primary"
              keyboardFocused={false}
              onClick={this.filterClick}
            >
              Filter
            </Button>
          </div>
        </div>
        {this.props.browser.events.fetching ? (
          <div> Loading... </div>
        ) : (
          <TableNew
            columns={this.state.columns}
            items={this.props.browser.events.data}
            tableKey="BrowserEvents"
            showDetails={true}
            detailsRenderer={(item) => {
              return <EventTableDetails item={item} />;
            }}
          />
        )}
      </div>
    );
  }
}
export default EventTableComponent;
